module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst {\ncompany,\nperson,\nnicknamePerson,\ncontactPerson,\nlocation,\ncolleagues,\nshowDetails,\ntext,\nshowFullTextButtonSymbol,\nbuttons,\nmultilineGranted,\nadditionalClass,\n} = model\nconst showName = !colleagues\nlet name = model.name || '-'\nlet entity = {}\nif(company){\nentity = company\nconst parts = []\nif(company.companyName) parts.push(company.companyName);\nif(parts.length > 0){\nname = parts.join(' ')\n}\n} else if(person){\nentity = person\nconst parts = []\nif(person.title)       parts.push(person.title);\nif(person.firstname)   parts.push(person.firstname);\nif(person.lastname)    parts.push(person.lastname);\nif(person.capacity)    parts.push(`(${person.capacity})`);\nif(person.nickname)    parts.push(`à ${person.nickname}`);\nif(parts.length > 0){\nname = parts.join(' ')\n}\n} else if(nicknamePerson){\nentity = nicknamePerson\nname = nicknamePerson.nickname || nicknamePerson.firstname || '???'\n} else if(contactPerson){\nentity = contactPerson\nname = contactPerson.name || '???'\n} else if(location){\nentity = location\nname = location.name || location.url\n}\nconst additionalClasses = []\nconst preparedColleagues = []\nif(colleagues){\nadditionalClasses.push('contentFullWidth')\nconst contractorsByID = {}\nfor(const j in (colleagues || {}).jobs || {}){\nconst job = colleagues.jobs[j]\nconst employee = job.employee || {}\nconst contractor = job.contractor || {}\nif(job.employeeID && job.employeeID != colleagues.employeeID){\nconst parts = []\nlet name = ''\nif(employee.nickname)       parts.push(`${employee.nickname}`);\nelse {\nif(employee.title)       parts.push(employee.title);\nif(employee.firstname)   parts.push(employee.firstname);\nif(employee.lastname)    parts.push(employee.lastname);\n}\nif(parts.length > 0){\nname = parts.join(' ')\n}\nif(name){\npreparedColleagues.push({\ntype: employee.type,\nnameKey: String(name).toLowerCase(),\nname: name,\nmobile: employee.mobile\n})\n}\n} else if(job.contractorID){\nif(contractorsByID[job.contractorID]) {\ncontractorsByID[job.contractorID].count++\n} else {\ncontractorsByID[job.contractorID] = {\ncount: 1,\ncontractor\n}\n}\n}\n}\nfor(const contractorID in contractorsByID){\nconst {\ncontractor,\ncount\n} = contractorsByID[contractorID] || {}\nconst companyName = contractor.companyName || '???'\nconst name = `<i class=\"fi fi-contractors\"></i>${companyName}: ${count || 0}`\npreparedColleagues.push({\nnameKey: String(companyName).toLowerCase(),\nname: name,\n})\n}\npreparedColleagues.sort((a, b) => {\nif(a.nameKey < b.nameKey) return -1;\nif(a.nameKey > b.nameKey) return 1;\nreturn 0\n})\n}\nif(multilineGranted){\nadditionalClasses.push('multilineGranted')\n}\nif(additionalClass){\nadditionalClasses.push(additionalClass)\n}\nconst additionalAttributes = []\nif(additionalClasses.length > 0){\nadditionalAttributes.push(`class=\"${additionalClasses.join(' ')}\"`)\n}\n%><div <%- additionalAttributes.join(' ')%>>\n<div class=\"content\">\n<label><%= storage.__(model.labelKey) %></label>\n<% if(colleagues){ %>\n<div class=\"colleagues\">\n<%\nfor(const colleague of preparedColleagues){\nif(colleague.mobile && showDetails){\n%><a class=\"filled\" href=\"tel:<%- colleague.mobile %>\"><%\nif(colleague.type === 'external'){\n%><i class=\"fi fi-employee-external\"></i><%\n}\n%><%- colleague.name %></a><%\n} else {\n%><a><%- colleague.name %></a><%\n}\n}\n%>\n</div>\n<% } else if(text) { %>\n<div class=\"text\">\n<%= text %>\n</div>\n<% } else { %>\n<div class=\"name\">\n<%= name %>\n</div>\n<% } %>\n</div>\n<div class=\"buttons\">\n<% if(buttons){ %>\n<% utils.forEach(buttons, function(button){ %>\n<%- include('../../core/form/elements/buttons/default', { formMapping: button }); %>\n<% }); %>\n<% } %>\n<% if(showDetails){ %>\n<% if(entity.tel){ %>\n<a class=\"tel\" href=\"tel:<%= entity.tel %>\"><i class=\"fi fi-tel\"></i></a>\n<% } %>\n<% if(entity.mobile){ %>\n<a class=\"mobile\" href=\"tel:<%= entity.mobile %>\"><i class=\"fi fi-mobile\"></i></a>\n<% } %>\n<% } %>\n<% if(entity.url){ %>\n<a class=\"location\" href=\"<%= entity.url %>\" target=\"_blank\"><i class=\"fi fi-open-location\"></i></a>\n<% } %>\n</div>\n</div>"
  , __filename = "components/templates/crew/projects/viewerField.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const {
company,
person,
nicknamePerson,
contactPerson,
location,
colleagues,
showDetails,
text,
showFullTextButtonSymbol,
buttons,
multilineGranted,
additionalClass,
} = model
const showName = !colleagues
let name = model.name || '-'
let entity = {}
if(company){
entity = company
const parts = []
if(company.companyName) parts.push(company.companyName);
if(parts.length > 0){
name = parts.join(' ')
}
} else if(person){
entity = person
const parts = []
if(person.title)       parts.push(person.title);
if(person.firstname)   parts.push(person.firstname);
if(person.lastname)    parts.push(person.lastname);
if(person.capacity)    parts.push(`(${person.capacity})`);
if(person.nickname)    parts.push(`à ${person.nickname}`);
if(parts.length > 0){
name = parts.join(' ')
}
} else if(nicknamePerson){
entity = nicknamePerson
name = nicknamePerson.nickname || nicknamePerson.firstname || '???'
} else if(contactPerson){
entity = contactPerson
name = contactPerson.name || '???'
} else if(location){
entity = location
name = location.name || location.url
}
const additionalClasses = []
const preparedColleagues = []
if(colleagues){
additionalClasses.push('contentFullWidth')
const contractorsByID = {}
for(const j in (colleagues || {}).jobs || {}){
const job = colleagues.jobs[j]
const employee = job.employee || {}
const contractor = job.contractor || {}
if(job.employeeID && job.employeeID != colleagues.employeeID){
const parts = []
let name = ''
if(employee.nickname)       parts.push(`${employee.nickname}`);
else {
if(employee.title)       parts.push(employee.title);
if(employee.firstname)   parts.push(employee.firstname);
if(employee.lastname)    parts.push(employee.lastname);
}
if(parts.length > 0){
name = parts.join(' ')
}
if(name){
preparedColleagues.push({
type: employee.type,
nameKey: String(name).toLowerCase(),
name: name,
mobile: employee.mobile
})
}
} else if(job.contractorID){
if(contractorsByID[job.contractorID]) {
contractorsByID[job.contractorID].count++
} else {
contractorsByID[job.contractorID] = {
count: 1,
contractor
}
}
}
}
for(const contractorID in contractorsByID){
const {
contractor,
count
} = contractorsByID[contractorID] || {}
const companyName = contractor.companyName || '???'
const name = `<i class="fi fi-contractors"></i>${companyName}: ${count || 0}`
preparedColleagues.push({
nameKey: String(companyName).toLowerCase(),
name: name,
})
}
preparedColleagues.sort((a, b) => {
if(a.nameKey < b.nameKey) return -1;
if(a.nameKey > b.nameKey) return 1;
return 0
})
}
if(multilineGranted){
additionalClasses.push('multilineGranted')
}
if(additionalClass){
additionalClasses.push(additionalClass)
}
const additionalAttributes = []
if(additionalClasses.length > 0){
additionalAttributes.push(`class="${additionalClasses.join(' ')}"`)
}

    ; __line = 115
    ; __append("<div ")
    ; __append( additionalAttributes.join(' '))
    ; __append(">\n<div class=\"content\">\n<label>")
    ; __line = 117
    ; __append(escapeFn( storage.__(model.labelKey) ))
    ; __append("</label>\n")
    ; __line = 118
    ;  if(colleagues){ 
    ; __append("\n<div class=\"colleagues\">\n")
    ; __line = 120
    ; 
for(const colleague of preparedColleagues){
if(colleague.mobile && showDetails){

    ; __line = 123
    ; __append("<a class=\"filled\" href=\"tel:")
    ; __append( colleague.mobile )
    ; __append("\">")
    ; 
if(colleague.type === 'external'){

    ; __line = 125
    ; __append("<i class=\"fi fi-employee-external\"></i>")
    ; 
}

    ; __line = 127
    ; __append( colleague.name )
    ; __append("</a>")
    ; 
} else {

    ; __line = 129
    ; __append("<a>")
    ; __append( colleague.name )
    ; __append("</a>")
    ; 
}
}

    ; __line = 132
    ; __append("\n</div>\n")
    ; __line = 134
    ;  } else if(text) { 
    ; __append("\n<div class=\"text\">\n")
    ; __line = 136
    ; __append(escapeFn( text ))
    ; __append("\n</div>\n")
    ; __line = 138
    ;  } else { 
    ; __append("\n<div class=\"name\">\n")
    ; __line = 140
    ; __append(escapeFn( name ))
    ; __append("\n</div>\n")
    ; __line = 142
    ;  } 
    ; __append("\n</div>\n<div class=\"buttons\">\n")
    ; __line = 145
    ;  if(buttons){ 
    ; __append("\n")
    ; __line = 146
    ;  utils.forEach(buttons, function(button){ 
    ; __append("\n")
    ; __line = 147
    ; __append( include('../../core/form/elements/buttons/default', { formMapping: button }) )
    ; __append("\n")
    ; __line = 148
    ;  }); 
    ; __append("\n")
    ; __line = 149
    ;  } 
    ; __append("\n")
    ; __line = 150
    ;  if(showDetails){ 
    ; __append("\n")
    ; __line = 151
    ;  if(entity.tel){ 
    ; __append("\n<a class=\"tel\" href=\"tel:")
    ; __line = 152
    ; __append(escapeFn( entity.tel ))
    ; __append("\"><i class=\"fi fi-tel\"></i></a>\n")
    ; __line = 153
    ;  } 
    ; __append("\n")
    ; __line = 154
    ;  if(entity.mobile){ 
    ; __append("\n<a class=\"mobile\" href=\"tel:")
    ; __line = 155
    ; __append(escapeFn( entity.mobile ))
    ; __append("\"><i class=\"fi fi-mobile\"></i></a>\n")
    ; __line = 156
    ;  } 
    ; __append("\n")
    ; __line = 157
    ;  } 
    ; __append("\n")
    ; __line = 158
    ;  if(entity.url){ 
    ; __append("\n<a class=\"location\" href=\"")
    ; __line = 159
    ; __append(escapeFn( entity.url ))
    ; __append("\" target=\"_blank\"><i class=\"fi fi-open-location\"></i></a>\n")
    ; __line = 160
    ;  } 
    ; __append("\n</div>\n</div>")
    ; __line = 162
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/crew/projects/viewerField.ejs

}